import React, { Component } from "react";
import { connect } from "react-redux";
import { formValueSelector, change } from "redux-form";
import CroField from "./CroField";
import AutoComplete from "../../../../components/form/AutoComplete";
import { countryChange } from "../../CroUtils";
import * as V from "../../../../utils/formValidation";
//import { getCzechRepublic } from '../../CroActions';
import { CZECH_REPUBLIC_ID } from "../../constants";

class CroCountry extends Component {
  // componentWillReceiveProps(nextProps) {
  //   console.log(this.props.country, nextProps.country)
  //   const { dispatch, change, name } = this.props;
  //   getCzechRepublic(dispatch)
  //     .then(result => {
  //       if (this.props.country === undefined) change(`${name}.country`, result);
  //       if (this.props.country && nextProps.country && this.props.country === CZECH_REPUBLIC_ID && nextProps.country !== CZECH_REPUBLIC_ID) change(`${name}.country`, nextProps.country)
  //     })
  // }

  componentWillReceiveProps(nextProps) {
    const { change, name, defaultCountry } = this.props;
    if (this.props.country === undefined && defaultCountry) {
      change(`${name}.country`, defaultCountry);
    }
    if (
      this.props.country &&
      nextProps.country &&
      this.props.country === CZECH_REPUBLIC_ID &&
      nextProps.country !== CZECH_REPUBLIC_ID
    )
      change(`${name}.country`, nextProps.country);
  }

  render() {
    const {
      country,
      change,
      disabled,
      name,
      title,
      className,
      helpEnum,
      validate = [] /*, form */,
    } = this.props;

    return (
      <CroField
        className={className}
        title={title}
        name={`${name}.country`}
        component={AutoComplete}
        url="/api/ciselniky/staty"
        disabled={disabled}
        validate={[V.isDictionary, ...validate]}
        onChange={countryChange(change, `${name}.municipality`, country)}
        helpEnum={helpEnum}
        operation="STARTWITH"
      />
    );
  }
}

export default connect(
  (state, { name, form }) => ({
    country: formValueSelector(form)(state, `${name}.country`),
  }),
  (dispatch, { form }) => ({
    change: (field, value) => dispatch(change(form, field, value)),
  }),
)(CroCountry);
